export const hasValidContent = (value?: string | null) =>
  typeof value === 'string' && value.trim().length > 0

// Reexportado para compatibilidade; a implementação real mora em src/utils/reviews
// pois agora é compartilhada com useProductReviewSummary (card do carrinho).
export { normalizeReviewResponse } from 'src/utils/reviews/normalizeReviewResponse'
